module.exports = __webpack_public_path__ + "static/media/apartment18.bcf2b865.jpg";